import React from "react";
import { withPreloadedJSON } from "@wss/hypernova";
import { createRoot } from "@wss/react";
import { initSentry } from "@wss/error-tracking/sentry";
import {
  logErrorBoundaryToSentry,
  PageFallback,
  ErrorBoundary,
} from "@wss/error-tracking/error-boundary";
import App from "~/App";
import { BlogHeaderWithData } from "../BlogHeader/index.client";
import { BlogFooterWithData } from "../BlogFooter/index.client";
import BlogPostContent, { BlogPostContentProps } from "./BlogPostContent";
import "~/fonts/fontello/css/fontello-top.less";
import "~/less/_critical/include.less";
import "../styles-brochure-blog.less";

/** Enable hot reloading */
module.hot?.accept();

initSentry("Blog Post Content");

function BlogPostContentPage(props: BlogPostContentProps): JSX.Element {
  return (
    <ErrorBoundary
      fallback={<PageFallback />}
      onError={logErrorBoundaryToSentry}
    >
      <BlogPostContent {...props} />
    </ErrorBoundary>
  );
}

const BlogPostContentPageWithData = withPreloadedJSON(
  BlogPostContentPage,
  "BlogPostContent",
);

const root = createRoot(document.querySelector("#root"));

root.render(
  <App>
    <BlogHeaderWithData />
    <BlogPostContentPageWithData />
    <BlogFooterWithData />
  </App>,
);
